<div class="logo-container">
    <div class="logo-preview" *ngIf="feature.value?.url">
      <img [src]="feature.value.url" alt="Logo preview">
    </div>
    <div class="logo-upload">
      <input type="file" (change)="onFileSelected($event)" accept="image/*" #fileInput style="display: none;">
      <button pButton type="button" (click)="fileInput.click()" label="Upload Logo"></button>
    </div>
  </div>